var render = function render(){var _vm=this,_c=_vm._self._c;return _c('LandingPage',[_c('p',[_c('button',{staticClass:"btn-standard",attrs:{"disabled":_vm.loading,"type":"submit"},domProps:{"textContent":_vm._s(_vm.buttonText)},on:{"click":_vm.handleRegister}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }